/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-get, ember/require-tagless-components */
import { action } from '@ember/object';
import Component from '@ember/component';

export default class ConfirmDeleteDialog extends Component {
  /** attrs **/
  // entityType is the type of entity to be deleted.
  entityType = '';

  // entityLabel is the label of the entity being deleted to inform the user.
  entityLabel = '';

  // errorMessage is a string that will be displayed to the user if there is an
  // error on attempting deletion.
  errorMessage = '';

  // onClose provides a function that will be called based on the users decision
  // to confirm the deletion. The function should close the dialog unless an
  // error occurs performing the action.
  // Returns a boolean indicating if the deletion was confirmed.
  onDelete() {}

  @action
  handleDelete(confirmed) {
    this.get('onDelete')(confirmed);
  }
}
